import React, { Component } from "react"
import { connect } from 'react-redux'
import { msg } from '../Notifications/MsgBox';
import { Input } from "../core";

import {
    getFileAction, uploadFileAction
} from '../../redux/actions/UploadAction'

class UploadPanelCommittee extends Component {
    constructor(props) {
        super(props)
        this.file = React.createRef()
        //this.defaultFileName = this.props.defaultFileName != null ? this.props.defaultFileName : 'เอกสารแนบ';
        this.file_category = this.props.file_category != null ? this.props.file_category : 'N';

        this.state = {
            defaultFileName: this.props.defaultFileName != null ? this.props.defaultFileName : 'เอกสารแนบ',
            local_selectedFile: null,
            loaded: 0,

            upload_files: null,

            transaction: null,
            t_MR_ATTACHMENTS: [
                {
                    "running": 0,
                    "transaction_no": null,
                    "id": null,
                    "file_name": null,
                    "file_type": null,
                    "create_date": null,
                    "create_by": null,
                    "update_date": null,
                    "update_by": null,
                    "isActive": true
                }
            ],
        }

        this.handleSubmit = this.handleSubmit.bind(this)
        this.onChangeHandler = this.onChangeHandler.bind(this)
        this.onClickHandler = this.onClickHandler.bind(this)
        this.onCancleHandler = this.onCancleHandler.bind(this)

    }

    onChangeHandler = event => {
        let { defaultFileName } = this.state
        let fileName = event.target.files[0].name ? event.target.files[0].name : defaultFileName
        let fileNameOnly = fileName
        let fileNameBeforChange = this.state.defaultFileName
        let fileNames = fileName.split('.')
        if (fileNames != null && fileNames.length > 1) {
            let surname = '.' + fileNames[fileNames.length - 1]
            fileNameOnly = fileName.replace(surname, '')

        }
        if (event.target.files.length === 0) {
            this.file.current.value = ''
            window.$(`#filename_${this.file_category}`).val(fileNameOnly);
            window.$(`#file_${this.file_category}`).val('');
            this.setState({
                local_selectedFile: '',
                loaded: 0,
            })
            return
        }

        var regex_symbols = /[!$%^&*()+|~=`{}\[\]:\/;<>?,@#]/;
        var size = event.target.files[0].size / 1024 / 1024
        var fn = this.file.current.value
        //const fileExtLength = 4
        const fileNameLength = 74

        if (size > 10) {
            msg.error('ขนาดไฟล์ เกิน 10 MB')
            this.file.current.value = ''
            window.$(`#filename_${this.file_category}`).val(fileNameBeforChange);
            window.$(`#file_${this.file_category}`).val('');
            this.setState({
                local_selectedFile: '',
                loaded: 0,
            })
            return
        }
        //else if (fn)
        else if (fn.substring(fn.lastIndexOf('\\') + 1).length > fileNameLength) {
            msg.error(`ชื่อไฟล์แนบต้องไม่เกิน ${fileNameLength} ตัวอักษร กรุณาแก้ไขชื่อไฟล์ แล้วแนบไฟล์ใหม่อีกครั้ง`)
            this.file.current.value = ''
            window.$(`#filename_${this.file_category}`).val(fileNameBeforChange);
            window.$(`#file_${this.file_category}`).val('');
            this.setState({
                local_selectedFile: '',
                loaded: 0,
            })
            return

        }
        else if (regex_symbols.test(fn.substring(fn.lastIndexOf('\\') + 1))) {
            msg.error(`ชื่อไฟล์แนบไม่สามารถใช้อักขระพิเศษได้`)
            this.file.current.value = ''
            window.$(`#filename_${this.file_category}`).val(fileNameBeforChange);
            window.$(`#file_${this.file_category}`).val('');
            this.setState({
                local_selectedFile: '',
                loaded: 0,
            })
            return
        }
        else if (fn.substring(fn.lastIndexOf('.') + 1) != "pdf" && fn.substring(fn.lastIndexOf('.') + 1) != "PDF") {
            msg.error('ไฟล์แนบต้องเป็นไฟล์ PDF เท่านั้น')
            this.file.current.value = ''
            window.$(`#filename_${this.file_category}`).val(fileNameBeforChange);
            window.$(`#file_${this.file_category}`).val('');
            this.setState({
                local_selectedFile: '',
                loaded: 0,
            })
            return

        }
        else {
            this.setState({
                local_selectedFile: event.target.files[0],
                loaded: 0,
            })
            this.props.onChangeSelectedFile(event.target.files[0])
        }

        if (fileNameOnly !== "" && fileNameOnly) {
            this.setState({
                defaultFileName: fileNameOnly
            })
        }
    }

    validateFileUpload(file) {
        try {
            let { defaultFileName } = this.state
            if (file != "") {
                if (!defaultFileName || defaultFileName.trim() === '') {
                    msg.error('กรุณาระบุชื่อเอกสารแนบ')
                    return false
                }
                return this.props.onValidate(file)
            }
            else {
                msg.error('กรุณาเลือกไฟล์ที่ต้องการอัพโหลด')
                return false
            }

        } catch (error) {

        }

        return false
    }

    async onClickHandler() {
        let { transaction_no, file_category, onUploadComplete, selectedFile, file_transaction_no } = this.props;
        let { local_selectedFile, defaultFileName } = this.state;
        if (selectedFile !== local_selectedFile) {
            local_selectedFile = selectedFile
            this.setState({
                local_selectedFile: selectedFile,
                loaded: 0,
            })
        }
        let createBy = 'admin', fileType = 'MrFile';

        const isValid = this.validateFileUpload(selectedFile)
        let getFileName = window.$(`#filename_${this.file_category}`).val();
        let getfileTransactionNo = window.$(`#file_transaction_no`).val();
        console.log('getfileTransactionNo', getfileTransactionNo)

        if (isValid) {
            //pack data
            const data = new FormData()
            await
                data.append('transactionNo', file_transaction_no)
            data.append('createBy', createBy)
            data.append('file', local_selectedFile)
            data.append('fileType', fileType)
            data.append('fileCategory', file_category)
            data.append('fileDescription', getFileName)
            //call upload action
            this.file.current.value = ''
            window.$(`#filename_${this.file_category}`).val(defaultFileName);
            window.$(`#file_${this.file_category}`).val('');

            this.props.uploadFile(data).then(() => {

                this.props.getFile(this.props.transaction_no).then(() => {
                    onUploadComplete();
                })


            })
                .catch(error => console.log("error : " + error));

            this.setState({
                local_selectedFile: '',
                loaded: 0,
                defaultFileName: 'เอกสารแนบ'
            })
            this.props.onChangeSelectedFile('')
        }

        //else this.props.onUploadComplete();
    }

    onCancleHandler = () => {
        this.setState({
            local_selectedFile: '',
            loaded: 0,
        })
        this.props.onChangeSelectedFile('')
        this.file.current.value = ''
        window.$(`#filename_${this.file_category}`).val(this.defaultFileName);
        window.$(`#file_${this.file_category}`).val('');
        if (this.props.onUploadCancel !== undefined){
            this.props.onUploadCancel()
        }
    }

    async handleSubmit(event) {
        event.preventDefault()
    }

    async handleChange(event) {
        const value = event.target.value;
        const name = event.target.name;

        await this.setState({
            defaultFileName: value,
        });

    }

    render() {
        const { defaultFileName } = this.state
        const { file_category, file_transaction_no } = this.props;

        return (
            <div>
                <div className="rrs-detail-data sp-table-container">
                    <div className="row">
                        <div className="col-12 d-flex align-items-center">
                            <i className="icon btn-plus" />
                            <span className="ml-3">Browse file here  <small>(The maximum file size is 10 MB)</small></span>
                        </div>
                    </div>
                    <div className="rrs-file-browse">
                        <input accept="application/pdf" type="file" id={`file_${file_category}`} name="singleInputFileName" ref={this.file} onChange={this.onChangeHandler} key={this.state.inputKey} />
                    </div>
                    <div className="container" style={{ marginTop: '10px' }}>
                        <div className="row">
                            <div className="col-2" style={{ padding: '0' }}>
                                <label >ชื่อเอกสารแนบ <span className="required">*</span> :</label>
                            </div>
                            <div className="col-10" style={{ paddingLeft: '5px', paddingRight: '0' }}>
                                <Input
                                    //type="text"
                                    id={`filename_${file_category}`}
                                    name="attachmentFilename"
                                    className="form-control"
                                    ref={this.defaultFileName}
                                    //defaultValue={defaultFileName}
                                    value={defaultFileName}
                                    onChange={(event) => this.handleChange(event)}
                                    maxlength="100"
                                />
                                {/* <Input
                                    //type="text"
                                    id={`file_transaction_no`}
                                    name="file_transaction_no"
                                    className="form-control"
                                    value={file_transaction_no}
                                    maxlength="100"
                                /> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mx-0 header-button-row mt-5">
                    <div className="col-12 sp-header-button-panel2">
                        <button href="#" className="sp-btn-icon btn-del" data-dismiss="modal" onClick={this.onCancleHandler}>
                            <i className="icon btn-order-delete"></i><span className="sp-btn-icon-label">Close</span>
                        </button>
                        <button href="#" className="sp-btn-icon" onClick={this.onClickHandler}>
                            <i className="icon btn-order-savedraft"></i><span className="sp-btn-icon-label">Upload</span>
                        </button>
                    </div>
                </div>
                {/* <p>Transaction No. : {this.props.transaction_no} - { this.props.file_category} </p> */}
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux, UploadRedux } = state
    return {
        transaction_no: MainRedux.transaction_no,
        upload_files: UploadRedux.upload_files,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        uploadFile: (data) => dispatch(uploadFileAction(data)),
        getFile: (transactionNo) => dispatch(getFileAction(transactionNo)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadPanelCommittee)